import { Box, Button, Container, Grid, MenuItem, Typography, useTheme, useMediaQuery } from '@mui/material';
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  setFilterCounts,
  setFilteredHolidayPackage,
  setHolidayPackage,
  setHolidayTypes,
  setRegionCounts,
  setRegionsTypes,
} from '../../../features/holidayPackage/holidayPackageSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppReducer';
import { API } from '../../../api/services';
import { API_METHOD } from '../../../api/services/apiMethods';
import { CustomContainer } from '../../../components/CustomContainer';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { FilterComponent } from '../../../components/FilterComponent';
import FindHolidayWidget from '../../../components/FindHolidayWidget';
import { ReactComponent as LocationIcon } from '../../../assets/icons/LocationIcon.svg';
import { PackageCard } from '../../../components/PackageCardComponent';
import { colors } from '../../../styles/colors';
import { countriesWithCountryCode } from '../../../constants/countries';
import { formatTime } from '../../../helpers/formatTime';
import { headerHeight } from '../../../common/headerHeight';
import { roundPrice, roundPriceTransfers } from '../../../helpers/RoundPrice';
import { setDialogState } from '../../../features/dialog/dialogSlice';
import { setFilterState } from '../../../features/filter/filterSlice';
import { setHotelId } from '../../../features/map/mapSlice';
import { setLoading } from '../../../features/loading/loadingSlice';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from '../../../helpers/isEmpty';
import { setHolidayDetailsState } from '../../../features/holidaySummary/holidaySummarySlice';
import { ReactComponent as SortFilterIcon } from '../../../assets/icons/SortFilterIcon.svg';
import MapIcon from '@mui/icons-material/Map';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import ScrollToTop from '../../../helpers/ScrollToTop';
import CustomSelectInput from '../../../components/CustomSelectInput';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { getLocalStorage, getSessionStorage, setLocalStorage, setSessionStorage } from '../../../helpers/storage';
import { sortRoom } from '../../../helpers/sortRoom';
import { setLottieLoading } from '../../../features/lottieLoader/lottieLoader';
import { dateSplit } from '../../../helpers/dateSplit';
import parseHTML from '../../../helpers/parseHtml';
import { setIsClickedFilters, setIsHolidayApiCall, setPosition } from '../../../features/commonState';
import { calculatePerPersonPrice } from '../../../helpers/calculatePerPersonPrice';
import { isDiscountValidDate } from '../../../helpers/isDiscountValidDate';
import { formatPrice } from '../../../helpers/formatPrice';
import ImportExportOutlinedIcon from '@mui/icons-material/ImportExportOutlined';
import CustomSelectInputListingPage from '../../../components/CustomSelectInputListingPage';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { fetchAsyncHotelDetails } from '../../../features/holidayPackage/hotelDetails';
var store = require('store');


export const HotelComponent = () => {
  //! States
  const dialogState = useAppSelector((state) => state.dialog.dialogState);
  const { holidayPackage, filteredHolidayPackage, status } = useAppSelector((state) => state.holidayPackage);
  const { filters } = useAppSelector((state: any) => state.filters);
  const { loading } = useSelector((state: any) => state.loading)
  const { holiday } = useAppSelector((state) => state.holidaySummary);
  const { flightRoom } = useAppSelector((state) => state.flightRoom);
  const [menu, setMenu] = useState(false);
  const { editSearch } = useSelector((state: any) => state.commonState);
  const selectedViewMode: string = getLocalStorage('viewMode') || 'grid';
  const [viewMode, setViewMode] = useState<'grid' | 'list'>(selectedViewMode as 'grid' | 'list');
  const navigate = useNavigate()
  const SortDropdownContent = ({ closeDropdown }: { closeDropdown?: () => void }) => (
    <>
      <Box
        sx={{
          padding: "9px 8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "2px",
          borderBottom: `1px solid${colors.grey[50]}`,
          background: colors.basics.white,
        }}
      >
        <Box display="flex" alignItems="center" gap="6px" fontWeight={400} fontSize={{ sm: "15px", xs: "14px" }}>
          <ImportExportOutlinedIcon sx={{
            color: colors.basics.primary,
          }} /> {filters?.sorting}
        </Box>
        <CloseRoundedIcon onClick={() => closeDropdown?.()} sx={{ cursor: 'pointer' }} />
      </Box>
      <Box
        sx={{
          maxHeight: 260,
          overflowY: "auto",
          padding: "8px 8px 8px 8px !important",
        }}
      >
        {/* <Typography
          variant="body2"
          fontSize={{ sm: "15px", xs: "14px" }}
          fontWeight={400}
          color={colors.grey[10]}
          sx={{ mb: "8px", mt: '8px', display: "block" }}
        >
          Sort by
        </Typography> */}
        {['Popularity', 'Price (low to high)', 'Price (high to low)'].map((item) => (
          <MenuItem
            key={item}
            value={item}
            onClick={() => {
              dispatch(setFilterState({ ...filters, sorting: item }));
              closeDropdown?.();
            }}
            sx={{
              padding: "8px 8px !important",
              my: "2px",
              background:
                filters?.sorting === item
                  ? colors.basics.pink + "!important"
                  : colors.basics.white,
              borderRadius: filters?.sorting === item ? "5px!important" : "unset",
            }}
          >
            <Typography variant="body2" display="flex" alignItems="center" gap="8px" fontSize={{ sm: "15px", xs: "14px" }} fontWeight={400} lineHeight="16px" color={colors.grey[10]}>
              {/* <ImportExportOutlinedIcon sx={{ color: colors.basics.primary}} /> */}
              {item}
            </Typography>
          </MenuItem>
        ))}
      </Box>
    </>
  );
  const elementRef = useRef(null);
  const { isClickedFilters, isHolidayApiCall, position } = useSelector((state: any) => state.commonState);
  // const [position, setPosition] = useState({ top: 0, left: 0 });
  // const [isClickedFilters, setIsClickedFilters] = useState(false)
  // const [isHolidayApiCall, setIsHolidayApiCall] = useState(false)

  const windowWidth = useWindowWidth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg')); // >= 600 && < 1024
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg')); // >= 1024
  const totalGuest = flightRoom.searchCriteria.adults + flightRoom.searchCriteria.childrens
  //! Hooks
  // const [hotelResultSort, setHotelResultSort] = useState('Popularity');

  //! Variables
  const dispatch = useAppDispatch();
  const filterBoxRef = useRef<any>();
  const stickyFilterSectionRef = useRef<any>(null);
  const mobileStickyFilterRef = useRef<any>(null);


  useEffect(() => {
    if (isMobile || isTablet) {
      if (getSessionStorage("click") === "false") {
        getPosition(filteredHolidayPackage, false, true)
      }
    }
  }, [isMobile, isTablet, filteredHolidayPackage, getSessionStorage("click")])

  useEffect(() => {
    if (status === 'SUCCESS' && getSessionStorage("transferApiCall") === "true") {
      handleSetTransfer();
    }
  }, [status, holidayPackage?.Packages?.results, getSessionStorage("transferApiCall")]);

  useEffect(() => {
    const onScroll = () => {
      if (filterBoxRef?.current) {
        if (filterBoxRef?.current?.getBoundingClientRect()?.top <= 10) {
        } else {
          filterBoxRef.current.style.height = '100%';
          filterBoxRef.current.style.overflow = 'auto';
          filterBoxRef.current.style.overflowX = 'hidden';
        }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    // display counts of filters hotel
    const counts: any = {};
    const facilities: string[] = [];
    const regionCounts: any = {}
    const regions: string[] = [];

    filteredHolidayPackage?.Packages?.results?.forEach((item: any, i: number) => {
      if (item?.HotelInfo?.resort_name) {
        regions.push(item.HotelInfo.resort_name)
      }

      item.facilities.forEach((ele: string) => {
        const parseString: string | null = parseHTML(ele).body.textContent || null;
        return parseString !== null && facilities.push(parseString)
      })
    })

    regions.forEach(item => {
      regionCounts[item] = (regionCounts[item] || 0) + 1;
    })

    const remove17AllHoliday = facilities.filter((f: any) => f !== "17~All Holidays")

    remove17AllHoliday.forEach(item => {
      const name = item.split('~')[1];
      counts[name] = (counts[name] || 0) + 1;
    });

    dispatch(setRegionCounts(regionCounts))
    dispatch(setFilterCounts(counts))
  }, [filteredHolidayPackage?.Packages?.results])


  useEffect(() => {
    if (status === 'SUCCESS') {
      //* Unique Array for facilities

      const facilities: string[] = [];
      holidayPackage?.Packages?.results?.forEach((item: any, i: number) =>
        item.facilities.forEach((ele: string) => {
          const parseString: string | null = parseHTML(ele).body.textContent || null;
          return parseString !== null && facilities.push(parseString)
        }));

      const remove17AllHoliday = facilities.filter((f: any) => f !== "17~All Holidays")

      var uniqueArr = Array.from(new Set(remove17AllHoliday));
      dispatch(setHolidayTypes(uniqueArr));

      //* unique array for region
      const regions: string[] = [];
      holidayPackage?.Packages?.results?.forEach(
        (item: any, i: number) => item.HotelInfo.resort_name && regions.push(item.HotelInfo.resort_name)
      );
      var uniqueRegions = Array.from(new Set(regions));
      dispatch(setRegionsTypes(uniqueRegions));
    }

    if (status === 'SUCCESS' && !holidayPackage) {
      dispatch(setLoading(false));
    }
  }, [status, holidayPackage?.Packages?.results]);

  useEffect(() => {
    if (holidayPackage?.Packages && status === 'SUCCESS') {
      let data = JSON.parse(JSON.stringify(holidayPackage));
      let filteredData = [];
      setTimeout(() => {
        //* Rating wise filters
        filteredData = holidayPackage.Packages.results.filter((item: any) => {
          const value = item.HotelInfo.hotel_classification === "0" ? Number(item.HotelInfo.hotel_rating) :
            item.HotelInfo.hotel_classification === "2" ? Number(item.HotelInfo.hotel_rating) === 5 ? 5 : Number(item.HotelInfo.hotel_rating) + 0.5 : Number(item.HotelInfo.hotel_rating)

          return filters.starRating.length === 0
            ? item
            : filters.starRating.includes(value);
        });

        //* Region wise filter
        if (filters.regionType.length) {
          filteredData = filteredData?.filter((item: any) => {
            if (filters.regionType.includes(item.HotelInfo?.resort_name)) {
              return item;
            }
            // return item
          });
        }

        //* Hotel Name wise filter
        if (filters.hotelName) {
          filteredData =
            filteredData.length > 0 &&
            filteredData?.filter((item: any) => {
              return item.SearchResult.hotel_name.toLowerCase().includes(filters.hotelName.toLowerCase());
            });
        }

        if (filters.price) {
          filteredData = filteredData.filter((item: any) => {

            const getTransfer: any = isEmpty(item?.SearchResult?.transfer?.pagedata[0]?.Transfer)
            // const tPrice = (getTransfer?.cust_tot_sell_amt ? (parseFloat(getTransfer?.cust_tot_sell_amt) * parseFloat(getTransfer?.exchange_rate)) : 0)

            const tPrice = getTransfer?.cust_tot_sell_amt ? parseFloat(getTransfer?.cust_tot_sell_amt) : 0
            const totalTransfer = roundPriceTransfers(tPrice, flightRoom.searchCriteria.isAdditionalTransferAmountAdd, totalGuest, flightRoom, item?.SearchResult?.transfer?.pagedata[0]?.Transfer.exchange_rate || 0)
            const transfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? totalTransfer : 0

            const data = sortRoom(item.SearchResult, filters);

            let price1: any = 0
            if (data.length > 0) {
              data.map((f: any) => {
                price1 = price1 + Number(f.total_package)
                return <></>
              })
            }

            const totalPrice = (price1) / totalGuest

            let finalPrice;

            if (flightRoom?.searchCriteria?.destination?.discountPrice?.isDiscountUK
              && process.env.REACT_APP_PROJECT_COUNTRY === "uk"
              && isDiscountValidDate()) {
              finalPrice = Number(formatPrice(String(calculatePerPersonPrice(roundPrice(totalPrice), totalGuest))));
            } else if (flightRoom?.searchCriteria?.destination?.discountPrice?.isDiscountIE
              && process.env.REACT_APP_PROJECT_COUNTRY === "ie"
              && isDiscountValidDate()) {

              finalPrice = Number(formatPrice(String(calculatePerPersonPrice(roundPrice(totalPrice), totalGuest))));
            } else {
              finalPrice = (Number(roundPrice(String(totalPrice))).toFixed());
            }
            const price = finalPrice;
            // });
            // const price = Number(
            //   Number(
            //     roundPrice(
            //       String(
            //         disTotalPrice
            //       )
            //     )
            //   ).toFixed()
            // )
            return price >= filters.price[0] && price <= filters.price[1]
          });
        }

        //* Holiday types wise filters
        if (filters.holidayType.length) {
          filteredData = filteredData.filter((item: any) => {
            // if (filters.holidayType.includes('18~All Inclusive Holidays')) {
            //* All Inclusive meal type filter
            const parseString: string | null = parseHTML(item.facilities).body.textContent || null;
            return (
              // item.SearchResult.Rooms[1].map((room: any) => room.meal_name).includes('All Inclusive') ||
              filters.holidayType.every((facility: string) => parseString !== null ? parseString.includes(facility) : false)
            );
            // } else {
            //   return filters.holidayType.some((facility: string) => parseString !== null ? parseString.includes(facility) : false);
            // }
          });
        }

        // * Sorting data
        if (filters.sorting === 'Popularity') {
          filteredData = filteredData
            .slice()
            .sort(
              (a: any, b: any) =>
                parseInt(a.HotelInfo.preferredOnSites) - parseInt(b.HotelInfo.preferredOnSites)
            );
        }
        if (filters.sorting === 'Price (low to high)') {
          filteredData = filteredData.slice().sort((a: any, b: any) => {

            const taPrice = a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? parseFloat(a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) : 0
            // const taPrice = a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? (parseFloat(a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) * parseFloat(a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate)) : 0

            const aTotalTransfer = roundPriceTransfers(taPrice, flightRoom.searchCriteria.isAdditionalTransferAmountAdd, totalGuest, flightRoom, a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate || 0)
            const aTransfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? aTotalTransfer : 0
            const tbPrice = b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? parseFloat(b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) : 0
            // const tbPrice = b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? (parseFloat(b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) * parseFloat(b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate)) : 0
            const bTotalTransfer = roundPriceTransfers(tbPrice, flightRoom.searchCriteria.isAdditionalTransferAmountAdd, totalGuest, flightRoom, b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate || 0)

            const bTransfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? bTotalTransfer : 0
            const aData = sortRoom(a.SearchResult, filters);
            const bData = sortRoom(b.SearchResult, filters);

            let aPrice: any = 0
            if (aData.length > 0) {
              aData.map((f: any) => {
                aPrice = aPrice + Number(f.total_package)
                return <></>
              })
            }
            // const aTotalPrice = (aPrice + aTransfer_add) / totalGuest
            const aTotalPrice = (aPrice) / totalGuest

            let bPrice: any = 0
            if (bData.length > 0) {
              bData.map((f: any) => {
                bPrice = bPrice + Number(f.total_package)
                return <></>
              })
            }

            // const bTotalPrice = (bPrice + bTransfer_add) / totalGuest
            const bTotalPrice = (bPrice) / totalGuest

            return (
              aTotalPrice -
              bTotalPrice
            );
          });
        }

        if (filters.sorting === 'Price (high to low)') {
          filteredData = filteredData.slice().sort((a: any, b: any) => {

            const taPrice = a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? (parseFloat(a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt)) : 0
            // const taPrice = a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? (parseFloat(a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) * parseFloat(a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate)) : 0

            const aTotalTransfer = roundPriceTransfers(taPrice, flightRoom.searchCriteria.isAdditionalTransferAmountAdd, totalGuest, flightRoom, a?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate || 0)
            const aTransfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? aTotalTransfer : 0

            const tbPrice = b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? parseFloat(b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) : 0
            // const tbPrice = b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt ? (parseFloat(b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.cust_tot_sell_amt) * parseFloat(b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate)) : 0
            const bTotalTransfer = roundPriceTransfers(tbPrice, flightRoom.searchCriteria.isAdditionalTransferAmountAdd, totalGuest, flightRoom, b?.SearchResult?.transfer?.pagedata[0]?.Transfer?.exchange_rate || 0)
            const bTransfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? bTotalTransfer : 0
            const aData = sortRoom(a.SearchResult, filters);
            const bData = sortRoom(b.SearchResult, filters);

            let aPrice: any = 0
            if (aData.length > 0) {
              aData.map((f: any) => {
                aPrice = aPrice + Number(f.total_package)
                return <></>
              })
            }

            let bPrice: any = 0
            if (bData.length > 0) {
              bData.map((f: any) => {
                bPrice = bPrice + Number(f.total_package)
                return <></>
              })
            }

            // const aTotalPrice = (aPrice + aTransfer_add) / totalGuest
            // const bTotalPrice = (bPrice + bTransfer_add) / totalGuest
            const aTotalPrice = (aPrice) / totalGuest
            const bTotalPrice = (bPrice) / totalGuest

            return (
              bTotalPrice - aTotalPrice
            );
          });
        }

        data.Packages.results = filteredData;
        dispatch(setFilteredHolidayPackage(data));
        // dispatch(setLoading(false));
      }, 500);
    }
  }, [filters, holidayPackage]);

  const getTransferCountryIdAndGetTransferPointsId = async (countryName: string, airport_code: string) => {
    const res = await API.post(API_METHOD.Transfer.GET_TRANSFER_COUNTRIES, []);

    const { data } = res;
    const country_id = Object.keys(data).find((key) => data[key] === countryName);
    let transfer_point_airport = await API.post(API_METHOD.Transfer.TRANSFER_POINTS, [
      {
        countryId: country_id,
        q: airport_code,
        json: true,
      },
    ]);

    transfer_point_airport = transfer_point_airport.data[0];
    store.set('TRANSFER_POINT_AIRPORT', transfer_point_airport);
    store.set('TRANSFER_COUNTRY_ID', country_id);
    return { transfer_point_airport, country_id };
  };

  const getOffers = async (hotelId: any) => {
    const body = [{ 'hotel_ids': hotelId }];
    let arr: any = [];
    try {
      const result = await API.post(API_METHOD.Misc.GET_CMS_OFFERS, body);
      const res = result?.data;

      if (Object.keys(res).length > 0) {
        const currentDate = new Date();
        const departureStartDate = new Date(dateSplit(flightRoom.searchCriteria.date[0], "/"));
        const departureEndDate = new Date(dateSplit(flightRoom.searchCriteria.date[1], "/"));


        Object.keys(res).forEach((id) => {
          const offers = res[id];

          // Filter with branchCode
          const filterBranchCode = offers?.filter((r: any) => r.key === process.env.REACT_APP_PROJECT_COUNTRY?.toUpperCase());
          // Filter with offerEndDate
          const filterOfferEndDate = filterBranchCode?.filter((offer: any) =>
            new Date(offer.bookFrom) <= currentDate && new Date(offer.bookTo) >= currentDate
          );
          // Filter with the dept start and end date
          // const filterInBetweenDepDatesOffer = filterOfferEndDate?.filter((d: any) => {
          //   const start = new Date(d.bookFrom);
          //   console.log('start :', start);
          //   start.setHours(0, 0, 0, 0);
          //   // console.log('start :', start);
          //   const end = new Date(d.bookTo);
          //   console.log('end :', end);
          //   end.setHours(0, 0, 0, 0);

          //   // console.log('end :', end);
          //   departureStartDate.setHours(0, 0, 0, 0);
          //   departureEndDate.setHours(0, 0, 0, 0);

          //   return start <= departureStartDate && end >= departureEndDate;
          // });
          // console.log('filterInBetweenDepDatesOffer :', filterInBetweenDepDatesOffer);

          // Filter with the top offers
          const filterShowInTop = filterOfferEndDate?.filter((r: any) => r.showInTopOffersBoxOnProductPage === "1");

          filterShowInTop?.forEach((offer: any) => {
            arr.push(offer);
          });

          // Filter without the top offers
          const withoutOne = filterOfferEndDate?.filter((r: any) => r.showInTopOffersBoxOnProductPage !== "1");

          withoutOne?.forEach((offer: any) => {
            arr.push(offer);
          });

        })
      }
    } catch (error) {
      console.error('Error fetching offers:', error);
    }

    return arr;
  };
  const getTransferPointHotelNameAndId = async (data: {
    country_id: string;
    transfer_point_airport_id: { id: string | number; name: string };
  }) => {
    const holidayPackageCopy = JSON.parse(JSON.stringify(holidayPackage));
    const outboundFlights = holidayPackageCopy.FlightDetails.outbound ? holidayPackageCopy?.FlightDetails?.outbound?.flights : [];
    const inboundFlights = holidayPackageCopy.FlightDetails.inbound ? holidayPackageCopy?.FlightDetails?.inbound?.flights : [];

    const transferDetails = {
      p_tm: outboundFlights.length > 0 ? formatTime(outboundFlights[outboundFlights?.length - 1]?.arrival_time) : "",
      d_tm: inboundFlights.length > 0 ? formatTime(inboundFlights[0]?.departure_time) : "",
      holidayPackageCopy: holidayPackageCopy
    };

    const resTransfers = await getTransfers(transferDetails)
    const hotelIdArray = holidayPackageCopy?.Packages?.results.map((item: any, index: number) => Number(item.SearchResult.hotel_id))
    const offerDetailsData = await getOffers(hotelIdArray)

    // Fetch hotel details for every hotel in the current package list
    const hotelDetailsResponses = await Promise.all(
      (hotelIdArray || []).map(async (id: number) => {
        try {
          const resp = await dispatch(fetchAsyncHotelDetails(id)).unwrap();
          return { id, data: resp };
        } catch (error) {
          console.error('Error fetching hotel details:', id, error);
          return { id, data: null };
        }
      })
    );

    const hotelDetailsById = new Map(
      hotelDetailsResponses
        .filter((item) => item.data)
        .map((item) => [item.id, item.data])
    );

    const promises = await holidayPackageCopy?.Packages?.results.map(async (item: any, index: number) => {

      if (offerDetailsData) {
        const offerDetailsHotelWise = offerDetailsData?.filter((itemm: any) => itemm.hotelId == item.SearchResult.hotel_id)
        item.SearchResult.offerDetails = offerDetailsHotelWise;
      }
      if (item.SearchResult.hotel_id) {
        if (resTransfers?.data && resTransfers?.data?.pagedata?.length > 0) {
          const getHotelSpecificTransfers: string[] = resTransfers?.data?.pagedata?.filter((e: any) => e.Transfer?.toTransferPointId === item?.HotelInfo?.transfer_point_id)
          if (getHotelSpecificTransfers?.length > 0) {
            // console.log(getHotelSpecificTransfers, item.SearchResult.hotel_id, item.SearchResult.hotel_name)
            item.SearchResult.transfer = {
              pagedata: await getHotelSpecificTransfers
            }
          } else {
            item.SearchResult.transfer = null;
          }
          item.SearchResult.transferSearchBody = isEmpty(resTransfers.transferSearchBody) !== "" ? resTransfers.transferSearchBody : null;
        }
      }

      // Attach fetched hotel details (TripAdvisor, Vendor, etc.) to each SearchResult
      const hotelDetailsPayload = hotelDetailsById.get(Number(item.SearchResult.hotel_id));
      if (hotelDetailsPayload) {
        item.SearchResult.hotelDetails = hotelDetailsPayload;
        item.SearchResult.tripAdvisor = hotelDetailsPayload?.Tripadv?.TripAdvisorCache || [];
        item.SearchResult.vendorInfo = hotelDetailsPayload?.HotelInfo || {};
        // item.SearchResult.VendorImages = hotelDetailsPayload?.VendorImages;
        item.SearchResult.VendorImages = hotelDetailsPayload?.VendorImages?.filter(
          (item: any) => item?.VendorImage?.image_width === "1800.00"
        );
      }

      return item;
    });
    const response: any = await Promise.all(promises);
    if (response?.length) {
      dispatch(setLoading(false));
      dispatch(setHolidayPackage(holidayPackageCopy));
      setSessionStorage("transferApiCall", "false")
      setTimeout(() => {
        dispatch(setLottieLoading(false))
        return <ScrollToTop />
      }, 10)

      return holidayPackageCopy;
    } else {
      dispatch(setLottieLoading(false))
      setSessionStorage("transferApiCall", "false")
      dispatch(setLoading(false));
    }
  };

  const get_transfer_search_data = async (data: any) => {
    const { p_tm, d_tm } = data;
    const TRANSFER_POINT_AIRPORT = store.get('TRANSFER_POINT_AIRPORT')
    const TRANSFER_COUNTRY_ID = store.get('TRANSFER_COUNTRY_ID');
    const countryName =
      countriesWithCountryCode[String(holidayPackage?.search_key?.location?.split(' / ')[1])];
    const childAges: { [key: string]: number } = {};
    // const numChildren275 = flightRoom.searchCriteria.childrens;
    const ageArray = flightRoom.searchCriteria.guest
      .map((item) => item.children.map((child: any) => child.age))
      .flat();
    for (let i = 1; i <= ageArray?.length; i++) {
      const age = Number(ageArray[i - 1]);
      childAges[Number(i).toString()] = parseInt(String(age));
    }
    const hotelName = data.holidayPackageCopy.Packages.results.map((item: any) => item.SearchResult.hotel_name)
    const checkInDateFilter = data.holidayPackageCopy.Packages.results.map((item: any) => item.SearchResult.Rooms)
    const checkInDate = checkInDateFilter[0]["1"][0].checkInDate;
    const checkOutate = checkInDateFilter[0]["1"][0].checkOutDate;
    // const tId = data.holidayPackageCopy.Packages.results.map((item: any) => String(item.HotelInfo.transfer_point_id + '-' + item.SearchResult.hotel_id))
    // add static id for bodrum destination
    const bodrumDestination = flightRoom.searchCriteria.destination["Searc ID"] === 11166
    const tId = data.holidayPackageCopy.Packages.results.map((item: any) => String(item.HotelInfo.transfer_point_id))
    const body = [{
      "isReturn": 1,
      "start_countryId": TRANSFER_COUNTRY_ID,
      "start_countryName": countryName,
      "fromTransferPointId": bodrumDestination ? 1253 : TRANSFER_POINT_AIRPORT?.id,
      "fromTransferPoint": bodrumDestination ? "Bodrum Airport (BJV) (Airport)" : TRANSFER_POINT_AIRPORT?.name,
      "destination": flightRoom?.searchCriteria?.destination["Searc ID"],
      // Multihotels: [1, 2, 3],
      toTransferPoint: hotelName,
      toTransferPointId: tId,
      // "date": flightRoom?.searchCriteria?.date?.[0].includes('T') ? dayjs(flightRoom.searchCriteria.date[0]).format("DD/MM/YYYY") : flightRoom.searchCriteria.date[0],
      "date": dayjs(checkInDate).format("DD/MM/YYYY"),
      "p_tm": p_tm,
      // "Returndate": flightRoom?.searchCriteria?.date?.[1].includes('T') ? dayjs(flightRoom.searchCriteria.date[1]).format("DD/MM/YYYY") : flightRoom.searchCriteria.date[1],
      "Returndate": dayjs(checkOutate).format("DD/MM/YYYY"),
      "d_tm": d_tm,
      "adults": flightRoom.searchCriteria.adults,
      "children": flightRoom.searchCriteria.childrens,
      "other_site": 1,
      data: Object.keys(childAges)?.length
        ? {
          ChildAge: childAges,
        }
        : {},
    }]

    return await API.post(API_METHOD.Transfer.TRANSFER_SEARCH, body)
      .then((res: any) => ({ data: res.data, transferSearchBody: body }))
      .catch((error: any) => false);
  };

  const handleSetTransfer = async () => {
    if (holidayPackage && Object.keys(holidayPackage)?.length) {
      const countryName =
        countriesWithCountryCode[String(holidayPackage?.search_key?.location?.split(' / ')[1])];
      const airport_code = holidayPackage?.search_key?.arrival;
      if (countryName) {
        getTransferCountryIdAndGetTransferPointsId(countryName, airport_code).then((res: any) => {
          if (res) {
            getTransferPointHotelNameAndId(res);
          }
        });
      }
    } else {
      dispatch(setLoading(false));
    }
  };

  const getTransfers = async (data: {
    p_tm: string,
    d_tm: string,
  }) => {
    const transfer = await get_transfer_search_data(data);
    return transfer
  }

  const randomId = function (length = 6) {
    return Math.random().toString(36).substring(2, length + 2);
  };

  const handleShowHotelsOnMap = () => {
    dispatch(setHolidayDetailsState({
      ...holiday,
      guest: flightRoom.searchCriteria.guest,
    }))
    dispatch(setHotelId([]));
    navigate(`/${randomId()}${window.location.search}`)
    dispatch(setDialogState({ ...dialogState, mapDialog: true }));
  };
  useEffect(() => {
    getPosition(filteredHolidayPackage, false, false)
  }, [])

  const getPosition = (data?: any, isButtonClicked?: boolean, filterApply?: any) => {
    const element = elementRef.current;
    if (element) {
      const rect = (element as any).getBoundingClientRect();
      const currentScrollY = window.scrollY || window.pageYOffset;

      // Calculate absolute position (scroll position + viewport position)
      const absoluteTop = currentScrollY + rect.top;

      const pos = {
        top: absoluteTop,
        left: rect.left,
      }

      // Get sticky filter section height dynamically
      const getStickyFilterHeight = () => {
        // For tablet/desktop, use stickyFilterSectionRef
        if (isTablet || isDesktop) {
          if (stickyFilterSectionRef.current) {
            const stickyRect = stickyFilterSectionRef.current.getBoundingClientRect();
            return stickyRect.height || 0;
          }
        }
        // For mobile, use mobileStickyFilterRef
        if (isMobile && mobileStickyFilterRef.current) {
          const mobileRect = mobileStickyFilterRef.current.getBoundingClientRect();
          return mobileRect.height || 0;
        }
        return 0;
      };

      if (isTablet) {
        // Tablet view (sm to lg: >= 600 && < 1024)
        if (filterApply !== true) {
          dispatch(setPosition(pos))
        }

        // Calculate scroll position accounting for sticky header and filter buttons
        const headerHeightValue = parseInt(headerHeight.tablet) || 84;
        const filterButtonHeight = getStickyFilterHeight() || 40; // Dynamic height or fallback
        const totalOffset = headerHeightValue + filterButtonHeight;

        setTimeout(() => {
          if (filterApply) {
            // When filter is applied, scroll to element position minus sticky elements
            const scrollTo = absoluteTop - totalOffset + 93;
            window.scrollTo({
              top: Math.max(0, scrollTo),
              behavior: 'smooth',
            });
          } else {
            // Normal scroll behavior
            const scrollTo = !loading && data?.Packages?.results?.length > 0
              ? absoluteTop - totalOffset + 95
              : 0;
            window.scrollTo({
              top: Math.max(0, scrollTo),
              behavior: 'smooth',
            });
          }
        }, 100)
      } else if (isMobile) {
        // Mobile view (xs: < 600)
        if (filterApply !== true) {
          dispatch(setPosition({
            top: pos.top - 182,
            left: pos.left
          }))
        }

        // Calculate scroll position accounting for sticky header and filter buttons
        const headerHeightValue = parseInt(headerHeight.mobile) || 64;
        const filterButtonHeight = getStickyFilterHeight() || 50; // Dynamic height or fallback
        const totalOffset = headerHeightValue + filterButtonHeight;

        setTimeout(() => {
          if (filterApply) {
            // When filter is applied, scroll to element position minus sticky elements
            const scrollTo = absoluteTop - totalOffset - 60;
            window.scrollTo({
              top: Math.max(0, scrollTo),
              behavior: 'smooth',
            });
          } else {
            // Normal scroll behavior
            const scrollTo = !loading && data?.Packages?.results?.length > 0
              ? absoluteTop - totalOffset - 500
              : 0;
            window.scrollTo({
              top: Math.max(0, scrollTo),
              behavior: 'smooth',
            });
          }
        }, 100)
      } else if (isDesktop) {
        // Desktop view (lg+: >= 1024)
        if (!isButtonClicked) {
          const headerHeightValue = parseInt(headerHeight.desktop) || 90;

          setTimeout(() => {
            if (!loading && data?.Packages?.results?.length > 0) {
              const scrollTo = absoluteTop - headerHeightValue - 20;
              window.scrollTo({
                top: Math.max(0, scrollTo),
                behavior: 'smooth',
              });
            } else {
              window.scrollTo({
                top: -100,
                behavior: 'smooth',
              });
            }
          }, 100)
        }
      }
    }
  }
  const queryData = useMemo(() => {
    const search = window.location.search
    const urlSearchParams = new URLSearchParams(search);
    const queryData: any = {};
    urlSearchParams.forEach((value, key) => {
      queryData[key] = value;
    });
    return queryData
  }, [])


  // Get number of columns based on window width
  const getColumnsCount = useMemo(() => {
    if (windowWidth >= 1200) return 3; // xl: 3 columns
    if (windowWidth >= 600) return 2; // sm/lg: 2 columns
    return 1; // xs: 1 column
  }, [windowWidth]);

  // Get initial items count based on columns
  const getInitialCount = useMemo(() => {
    if (getColumnsCount === 3) return 9; // xl: 3 columns - 9 hotels
    if (getColumnsCount === 2) return 8; // sm/lg: 2 columns - 8 hotels
    return 9; // xs: 1 column - 9 hotels
  }, [getColumnsCount]);

  const [filterPackages, setFilterPackages] = useState<any>(() => {
    // Calculate initial value based on current window width
    const cols = windowWidth >= 1200 ? 3 : windowWidth >= 600 ? 2 : 1;
    if (cols === 3) return 9; // xl: 3 columns - 9 hotels
    if (cols === 2) return 8; // sm/lg: 2 columns - 8 hotels
    return 9; // xs: 1 column - 9 hotels
  });

  // Track previous column count to detect breakpoint changes
  const prevColumnsCountRef = useRef(getColumnsCount);

  // Update filterPackages when breakpoint changes (column count changes)
  useEffect(() => {
    const prevColumns = prevColumnsCountRef.current;
    const currentColumns = getColumnsCount;

    // Only reset if the column count actually changed (breakpoint changed)
    if (prevColumns !== currentColumns) {
      setFilterPackages(getInitialCount);
      prevColumnsCountRef.current = currentColumns;
    }
  }, [getColumnsCount, getInitialCount]);

  const handleLoadMore = () => {
    const increment = getInitialCount; // Increment by initial count (9 for 3 cols, 8 for 2 cols, 9 for 1 col)
    setFilterPackages((prev: any) => prev + increment);
  }

  const handleShowLess = () => {
    setFilterPackages(getInitialCount); // Reset to initial count based on columns
  };

  const handleViewMode = (value: 'grid' | 'list') => {
    if (!value) return
    setViewMode(value);
    setLocalStorage('viewMode', value)
  }

  return (
    <Box >
      {/* <Box my='28px'>
          <div>hotels</div>
        </Box> */}

      <Box >

        <Box bgcolor={colors.grey[20]} sx={{
          pb: { md: '35px', sm: '16px', xs: '0px' },
          pt: { md: '35px', xs: '16px' },
          position: { xs: editSearch && 'sticky', sm: 'relative' },
          top: { xs: windowWidth < 376 ? '108px' : '118px', sm: '0' },
          zIndex: 1000,
        }}>
          <CustomContainer style={{ maxWidth: '1368px !important', padding: { sm: "0 20px !important", xs: '0 10px !important' } }}>
            <Box >
              {/* <Typography variant='h1' fontSize='28px' fontWeight={600} lineHeight='44px' mb='15px'>
                Find your perfect holiday
              </Typography> */}
              {/* {window.location.host.includes("localhost") && <h2 style={{ marginBottom: "10px" }}> Search date after 4 months</h2>} */}
              <FindHolidayWidget
                setIsHolidayApiCall={setIsHolidayApiCall}
                setIsClickedFilters={setIsClickedFilters}
                getPosition={getPosition}
              />
            </Box>
          </CustomContainer>
        </Box>
        <Box mt={{ md: '35px', sm: '0px', xs: '0' }} ref={elementRef} >

          <CustomContainer style={{ maxWidth: '1369px !important', padding: { sm: "0 20px !important", xs: '0 0px !important' } }}>
            {holidayPackage?.Packages?.results?.length &&
              (<Box display="flex"
                ref={stickyFilterSectionRef}
                flexDirection="row"
                padding={{ sm: "0 0", xs: '0 0px !important' }}
                // mb="30px"
                alignItems="center"            // ⭐ ADDED → vertically center all items
                justifyContent="space-between" // ⭐ ADDED → left title / right controls
                width="100%"
                sx={{
                  position: { sm: 'sticky', lg: '' },
                  top: { xs: headerHeight.mobile, sm: headerHeight.tablet, lg: 0 },
                  zIndex: 99,
                  backgroundColor: colors.basics.secondary,
                }}>
                <Box gap={1} display={windowWidth < 600 ? 'none' : 'flex'}>
                  <Typography variant='h1' fontSize={{ lg: '36px', sm: '32px', xs: '32px' }} fontWeight={400} lineHeight='50px'>
                    {filteredHolidayPackage?.Packages?.results.length} Holiday{filteredHolidayPackage?.Packages?.results.length > 1 ? 's' : ''} found
                  </Typography>
                </Box>
                <Box gap={1} display={windowWidth < 600 ? 'none' : 'flex'} mb={viewMode === "list" ? "20px" : "20px"}>
                  <Box display='flex' gap={1} alignItems='center' marginTop={'28px'}>
                    <Button
                      variant={viewMode === 'grid' ? 'contained' : 'outlined'}
                      onClick={() => handleViewMode('grid')}
                      sx={{
                        minWidth: '45px',
                        height: "45px",
                        p: { xs: '8px', sm: '10px' },
                        border: viewMode === 'grid' ? 'none' : `0.8px solid ${colors.grey[30]} !important`,
                        backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                        color: viewMode === 'grid' ? colors.basics.white : colors.basics.primary,
                        '&:hover': {
                          backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                          border: viewMode === 'grid' ? 'none' : '1px solid ' + colors.basics.primary,
                        },
                        width: "100%"
                      }}
                      disableRipple
                    >
                      <GridViewIcon fontSize='small' />
                    </Button>
                    <Button
                      variant={viewMode === 'list' ? 'contained' : 'outlined'}
                      onClick={() => handleViewMode('list')}
                      sx={{
                        minWidth: '45px',
                        height: "45px",
                        p: { xs: '8px', sm: '10px' },
                        border: viewMode === 'list' ? 'none' : `0.8px solid ${colors.grey[30]} !important`,
                        backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                        color: viewMode === 'list' ? colors.basics.white : colors.basics.primary,
                        '&:hover': {
                          backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                          border: viewMode === 'list' ? 'none' : '1px solid ' + colors.basics.primary,
                        },
                        width: "100%"
                      }}
                      disableRipple
                    >
                      <ViewListIcon fontSize='small' />
                    </Button>
                  </Box>

                  <Box display='flex' sx={{
                    gap: { xs: '40px', sm: 0 },
                    display: { xs: 'none', sm: "flex", lg: 'none' },
                    mt: "28px",
                    '& .MuiButton-root': {
                      marginTop: "-1px",
                      display: { xs: 'none', sm: 'flex', lg: "none" },
                    },
                    '@media (min-width:1024px) and (max-width:1150px)': {
                      display: 'flex',
                    },
                  }} >
                    {holidayPackage?.Packages?.results?.length > 0 &&
                      <Button
                        sx={{
                          mt: { sm: '10px', xs: '0' },
                          outline: 0,
                          border: { xs: '0 !important', sm: `1px solid ${colors.grey[30]} !important` },
                          p: { xs: 0, sm: '14px 23px' },
                          color: { xs: '#000', sm: '#FF3300' },
                          display: { xs: 'none', sm: "flex", lg: viewMode === "grid" && windowWidth >= 1024 && windowWidth <= 1150 ? 'flex' : 'none' },
                          // mr: { xs: 0, sm: '17px' },
                          maxHeight: '45px',
                          backgroundColor: { sm: 'transparent', xs: colors.grey[20] },
                          // ml: 1,
                          '&:hover': {
                            backgroundColor: sessionStorage.getItem('click') === 'true' ? 'transparent' : colors.grey[20],
                          },
                        }}
                        variant='outlined'
                        onClick={() => {
                          setSessionStorage("click", "true")
                          dispatch(setDialogState({ ...dialogState, filterDialog: true }))
                        }
                        }
                      >
                        <Box display={{ xs: 'none', sm: "flex", lg: viewMode === "grid" && windowWidth >= 1024 && windowWidth <= 1150 ? 'flex' : 'none' }} alignItems={'center'} sx={{
                          color: { sm: `${colors.basics.primary} !important`, xs: `${colors.grey[10]} !important` },
                          fontWeight: { xs: 700, sm: 400 },
                          '& svg': {
                            fill: `${colors.basics.primary} !important`
                          }
                        }} gap={1} >
                          <SortFilterIcon />
                          Filter & Sorting
                        </Box>
                        {/* <Typography
                              variant='body2'
                              color={colors.basics.primary}
                              display={{ xs: 'none', sm: 'block' }}
                            >
                              Filter by
                            </Typography> */}
                      </Button>
                    }
                    {/* {!loading && filteredHolidayPackage?.Packages?.results?.length > 0 &&
                          <Button
                            variant='outlined'
                            onClick={() => dispatch(setDialogState({ ...dialogState, mapDialog: true }))}
                            sx={{
                              mt: { sm: '10px', xs: '0' },
                              outline: 0,
                              border: { xs: '0 !important', sm: '1px solid !important' },
                              p: { xs: 0, sm: '14px 23px' },
                              color: { xs: '#000', sm: '#FF3300' },
                              display: { xs: 'flex', sm: 'none' },
                              mr: { xs: ' 5px', sm: '17px' },
                              maxHeight: '48px',
                              backgroundColor: colors.basics.white,
                            }}
                          >
                            <Box display={{ xs: 'flex', sm: 'none' }} sx={{
                              color: `${colors.basics.primary} !important`,
                              '& svg': {
                                fill: `${colors.basics.primary} !important`

                              }
                            }} alignItems={'center'} gap={1} onClick={handleShowHotelsOnMap} >
                              <MapIcon />
                              Map
                            </Box>
                          </Button>
                        }
                        {!loading && filteredHolidayPackage?.Packages?.results?.length > 0 && <Button
                          variant='text'
                          onClick={handleShowHotelsOnMap}
                          sx={{
                            p: 1,
                            minWidth: 'auto',
                            alignSelf: 'center',
                            display: { xs: 'none', sm: 'flex' },
                            mt: { sm: '10px', xs: '0' },
                          }}
                          endIcon={<LocationIcon />}
                          disableRipple={true}
                        >
                          <Typography
                            variant='body1'
                            fontWeight={500}
                            display={{ xs: 'none', sm: 'block' }}
                            // mt={{ sm: '10px', xs: '0' }}
                            sx={(theme) => ({ color: theme.palette.primary.main })}

                          >
                            Show on map
                          </Typography>
                        </Button>} */}
                    {/* <Box display='flex' gap={1} alignItems='center'>
                          <Button
                            variant={viewMode === 'grid' ? 'contained' : 'outlined'}
                            onClick={() => setViewMode('grid')}
                            sx={{
                              minWidth: 'auto',
                              p: { xs: '8px', sm: '10px' },
                              border: viewMode === 'grid' ? 'none' : '1px solid #E0E0E0',
                              backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                              color: viewMode === 'grid' ? colors.basics.white : colors.basics.primary,
                              '&:hover': {
                                backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                                border: viewMode === 'grid' ? 'none' : '1px solid ' + colors.basics.primary,
                              },
                            }}
                            disableRipple
                          >
                            <GridViewIcon fontSize='small' />
                          </Button>
                          <Button
                            variant={viewMode === 'list' ? 'contained' : 'outlined'}
                            onClick={() => setViewMode('list')}
                            sx={{
                              minWidth: 'auto',
                              p: { xs: '8px', sm: '10px' },
                              border: viewMode === 'list' ? 'none' : '1px solid #E0E0E0',
                              backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                              color: viewMode === 'list' ? colors.basics.white : colors.basics.primary,
                              '&:hover': {
                                backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                                border: viewMode === 'list' ? 'none' : '1px solid ' + colors.basics.primary,
                              },
                            }}
                            disableRipple
                          >
                            <ViewListIcon fontSize='small' />
                          </Button>
                        </Box> */}
                  </Box>

                  {filteredHolidayPackage?.Packages?.results?.length !== 0 &&
                    <Box sx={{
                      position: 'relative',
                      minWidth: '196px',
                      width: '100%',
                      '& .custom-dropdown-listing-page .dropdown-menu': {
                        top: "-2px !important",
                        right: "1px !important",
                        boxShadow: "0px 1px 6px -2px rgba(0,0,0,0.3) !important",
                      },
                      '& .dropdown-toggle span ': {
                        ml: '5px !important',
                      },
                      display: { xs: 'none', sm: 'none', lg: 'block' }
                    }}
                    >
                      <Typography variant='body1' color={colors.grey[10]} lineHeight='130%' fontWeight={700} display={{ xs: 'none', sm: 'block' }} fontFamily="Raleway" fontSize="16px">
                        Sort by
                      </Typography>
                      <CustomSelectInputListingPage
                        className={'dropdown-menu-sort'}
                        menu={windowWidth > 599 ? false : true}
                        ids="options"
                        boxStyle={{ minWidth: windowWidth < 600 ? "85px" : "155px" }}
                        // data={['Popularity', 'Price (low to high)', 'Price (high to low)']}
                        onChange={(e: any, n: any, v: any) => {
                          setSessionStorage("click", "false")
                          dispatch(setFilterState({ ...filters, sorting: v }));
                        }}
                        value={filters?.sorting}
                        paddingStyle="0px"
                        radiusStyle="5px"
                        children={<SortDropdownContent />}
                        StartIcon={<ImportExportOutlinedIcon color='primary' />}
                      // StartIcon={
                      //   <>
                      //     <Box fontSize={"16px"} display={{ xs: 'flex', sm: 'none' }} sx={{
                      //       color: `${colors.basics.primary} !important`,
                      //       '& svg': {
                      //         fill: `${colors.basics.primary} !important`
                      //       },

                      //     }} alignItems={'center'} onClick={() => setMenu(!menu)}>
                      //       <SwapVertIcon />
                      //       Sort
                      //     </Box>
                      //     <Typography variant='h3' fontWeight={500} display={{ xs: 'none', sm: 'block' }}>
                      //       Sort by:
                      //     </Typography>
                      //   </>
                      // }
                      // style={{ fontSize: '16px', maxWidth: '100px' }}
                      />
                    </Box>
                  }
                </Box>
              </Box>)}
            <Box display='flex' sx={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
              {holidayPackage?.Packages?.results?.length > 0 && <Box
                maxWidth='288px'
                width='100%'
                display={{ xs: 'none', lg: 'block' }}
                position='sticky'
                flexShrink={0}
                // // top={headerHeight.desktop}
                top={'94px'}
                mb={1}
                ref={filterBoxRef}
                mr='20px'
              >
                <FilterComponent getPosition={getPosition} isClickedFilters={isClickedFilters} setIsClickedFilters={setIsClickedFilters} viewMode={viewMode} />
              </Box>}
              <Box sx={{ width: '100%', maxWidth: '100%', flex: 1, minWidth: 0, boxSizing: 'border-box', mr: { lg: '0' } }}>
                {filteredHolidayPackage && Object.keys(filteredHolidayPackage)?.length !== 0 ? (
                  <>
                    <Box ref={mobileStickyFilterRef} display={{ xs: 'flex', sm: 'none' }} alignItems='center' flexDirection="row-reverse" sx={{
                      justifyContent: { xs: 'start', sm: filteredHolidayPackage?.Packages?.results?.length !== 0 ? 'space-between' : 'flex-end' },
                      position: { xs: 'sticky', lg: 'static' },
                      top: { xs: windowWidth < 376 ? !editSearch ? "110px" : "183px" : !editSearch ? "115px" : "185px", sm: '84px', lg: 'auto' },
                      backgroundColor: colors.grey[20],
                      borderBottom: { xs: `1px solid ${colors.grey[30]}`, sm: 'none' },
                      zIndex: 10,
                      pb: { xs: windowWidth < 376 ? '10px' : '10px', sm: "10px", lg: 0 },
                      pt: { xs: windowWidth < 376 ? '10px' : '15px', sm: "24px", lg: 0 },
                      mb: { xs: 0, sm: '14px' },
                      '& .MuiInputBase-root': {
                        mt: "0 !important"
                      },
                      '& .custom-dropdown': {
                        marginTop: 0,
                      },
                    }}>


                      {/* <Box gap={1} display={windowWidth < 566 ? 'none' : 'flex'}>
                        <Box display='flex' gap={1} alignItems='center' marginTop={'32px'}>
                          <Button
                            variant={viewMode === 'grid' ? 'contained' : 'outlined'}
                            onClick={() => setViewMode('grid')}
                            sx={{
                              minWidth: 'auto',
                              p: { xs: '8px', sm: '10px' },
                              border: viewMode === 'grid' ? 'none' : '1px solid #E0E0E0',
                              backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                              color: viewMode === 'grid' ? colors.basics.white : colors.basics.primary,
                              '&:hover': {
                                backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                                border: viewMode === 'grid' ? 'none' : '1px solid ' + colors.basics.primary,
                              },
                            }}
                            disableRipple
                          >
                            <GridViewIcon fontSize='small' />
                          </Button>
                          <Button
                            variant={viewMode === 'list' ? 'contained' : 'outlined'}
                            onClick={() => setViewMode('list')}
                            sx={{
                              minWidth: 'auto',
                              p: { xs: '8px', sm: '10px' },
                              border: viewMode === 'list' ? 'none' : '1px solid #E0E0E0',
                              backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                              color: viewMode === 'list' ? colors.basics.white : colors.basics.primary,
                              '&:hover': {
                                backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                                border: viewMode === 'list' ? 'none' : '1px solid ' + colors.basics.primary,
                              },
                            }}
                            disableRipple
                          >
                            <ViewListIcon fontSize='small' />
                          </Button>
                        </Box>

                        {filteredHolidayPackage?.Packages?.results?.length !== 0 &&
                          <Box>
                            <Typography variant='h3' fontWeight={700} display={{ xs: 'none', sm: 'block' }} fontFamily="Raleway" fontSize="16px">
                              Sort by
                            </Typography>
                            <CustomSelectInput
                              className={'dropdown-menu-sort'}
                              menu={windowWidth > 599 ? false : true}
                              ids="options"
                              boxStyle={{ minWidth: windowWidth < 600 ? "85px" : "155px" }}
                              data={['Popularity', 'Price (low to high)', 'Price (high to low)']}
                              onChange={(e: any, n: any, v: any) => {
                                setSessionStorage("click", "false")
                                dispatch(setFilterState({ ...filters, sorting: v }));
                              }}
                              value={filters?.sorting}
                              StartIcon={<ImportExportOutlinedIcon color='primary' />}
                            // StartIcon={
                            //   <>
                            //     <Box fontSize={"16px"} display={{ xs: 'flex', sm: 'none' }} sx={{
                            //       color: `${colors.basics.primary} !important`,
                            //       '& svg': {
                            //         fill: `${colors.basics.primary} !important`
                            //       },

                            //     }} alignItems={'center'} onClick={() => setMenu(!menu)}>
                            //       <SwapVertIcon />
                            //       Sort
                            //     </Box>
                            //     <Typography variant='h3' fontWeight={500} display={{ xs: 'none', sm: 'block' }}>
                            //       Sort by:
                            //     </Typography>
                            //   </>
                            // }
                            // style={{ fontSize: '16px', maxWidth: '100px' }}
                            />
                          </Box>
                        }
                      </Box> */}
                      <Box display='flex' sx={{
                        gap: { xs: '40px', sm: 0 },
                        '& .MuiButton-root': {
                          marginTop: "-1px"
                        }
                      }} >
                        {holidayPackage?.Packages?.results?.length > 0 &&
                          <Button
                            sx={{
                              mt: { sm: '10px', xs: '0' },
                              outline: 0,
                              border: { xs: '0 !important', sm: '1px solid !important' },
                              p: { xs: 0, sm: '14px 23px' },
                              color: { xs: '#000', sm: '#FF3300' },
                              display: { xs: 'flex', lg: 'none' },
                              mr: { xs: 0, sm: '17px' },
                              maxHeight: '48px',
                              backgroundColor: { sm: colors.basics.white, xs: colors.grey[20] },
                              ml: 1,
                              '&:hover': {
                                backgroundColor: { sm: colors.basics.white, xs: colors.grey[20] },
                              },
                            }}
                            variant='outlined'
                            onClick={() => {
                              setSessionStorage("click", "true")
                              dispatch(setDialogState({ ...dialogState, filterDialog: true }))
                            }
                            }
                          >
                            <Box display={{ xs: 'flex', md: 'none' }} alignItems={'center'} sx={{
                              color: { sm: `${colors.basics.primary} !important`, xs: `${colors.grey[10]} !important` },
                              fontWeight: { xs: 700, sm: 400 },
                              '& svg': {
                                fill: `${colors.basics.primary} !important`
                              }
                            }} gap={1} >
                              {/* Mobile Filter Button */}
                              <SortFilterIcon />
                              Filter & Sorting
                            </Box>
                            {/* <Typography
                              variant='body2'
                              color={colors.basics.primary}
                              display={{ xs: 'none', sm: 'block' }}
                            >
                              Filter by
                            </Typography> */}
                          </Button>
                        }
                        {/* {!loading && filteredHolidayPackage?.Packages?.results?.length > 0 &&
                          <Button
                            variant='outlined'
                            onClick={() => dispatch(setDialogState({ ...dialogState, mapDialog: true }))}
                            sx={{
                              mt: { sm: '10px', xs: '0' },
                              outline: 0,
                              border: { xs: '0 !important', sm: '1px solid !important' },
                              p: { xs: 0, sm: '14px 23px' },
                              color: { xs: '#000', sm: '#FF3300' },
                              display: { xs: 'flex', sm: 'none' },
                              mr: { xs: ' 5px', sm: '17px' },
                              maxHeight: '48px',
                              backgroundColor: colors.basics.white,
                            }}
                          >
                            <Box display={{ xs: 'flex', sm: 'none' }} sx={{
                              color: `${colors.basics.primary} !important`,
                              '& svg': {
                                fill: `${colors.basics.primary} !important`

                              }
                            }} alignItems={'center'} gap={1} onClick={handleShowHotelsOnMap} >
                              <MapIcon />
                              Map
                            </Box>
                          </Button>
                        }
                        {!loading && filteredHolidayPackage?.Packages?.results?.length > 0 && <Button
                          variant='text'
                          onClick={handleShowHotelsOnMap}
                          sx={{
                            p: 1,
                            minWidth: 'auto',
                            alignSelf: 'center',
                            display: { xs: 'none', sm: 'flex' },
                            mt: { sm: '10px', xs: '0' },
                          }}
                          endIcon={<LocationIcon />}
                          disableRipple={true}
                        >
                          <Typography
                            variant='body1'
                            fontWeight={500}
                            display={{ xs: 'none', sm: 'block' }}
                            // mt={{ sm: '10px', xs: '0' }}
                            sx={(theme) => ({ color: theme.palette.primary.main })}

                          >
                            Show on map
                          </Typography>
                        </Button>} */}
                        {/* <Box display='flex' gap={1} alignItems='center'>
                          <Button
                            variant={viewMode === 'grid' ? 'contained' : 'outlined'}
                            onClick={() => setViewMode('grid')}
                            sx={{
                              minWidth: 'auto',
                              p: { xs: '8px', sm: '10px' },
                              border: viewMode === 'grid' ? 'none' : '1px solid #E0E0E0',
                              backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                              color: viewMode === 'grid' ? colors.basics.white : colors.basics.primary,
                              '&:hover': {
                                backgroundColor: viewMode === 'grid' ? colors.basics.primary : 'transparent',
                                border: viewMode === 'grid' ? 'none' : '1px solid ' + colors.basics.primary,
                              },
                            }}
                            disableRipple
                          >
                            <GridViewIcon fontSize='small' />
                          </Button>
                          <Button
                            variant={viewMode === 'list' ? 'contained' : 'outlined'}
                            onClick={() => setViewMode('list')}
                            sx={{
                              minWidth: 'auto',
                              p: { xs: '8px', sm: '10px' },
                              border: viewMode === 'list' ? 'none' : '1px solid #E0E0E0',
                              backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                              color: viewMode === 'list' ? colors.basics.white : colors.basics.primary,
                              '&:hover': {
                                backgroundColor: viewMode === 'list' ? colors.basics.primary : 'transparent',
                                border: viewMode === 'list' ? 'none' : '1px solid ' + colors.basics.primary,
                              },
                            }}
                            disableRipple
                          >
                            <ViewListIcon fontSize='small' />
                          </Button>
                        </Box> */}
                      </Box>
                    </Box>
                    <Typography display={{ xs: 'block', sm: 'none' }} variant='h1' fontSize={'22px !important'} fontWeight={400} lineHeight='32px' p='10px 10px 0px 10px'>
                      {filteredHolidayPackage?.Packages?.results.length} Holiday{filteredHolidayPackage?.Packages?.results.length > 1 ? 's' : ''} found
                    </Typography>
                    {filteredHolidayPackage?.Packages?.results?.length !== 0 ? (
                      <Box
                        // padding={{ sm: "0 0 !important", xs: '0 10px !important' }}
                        sx={{
                          width: '100%',
                          maxWidth: '100%',
                          overflow: 'hidden',
                          boxSizing: 'border-box',
                          p: { sm: 0, xs: '10px' }
                        }}
                      >
                        {viewMode === 'grid' ? (
                          <Container maxWidth="lg" disableGutters>
                            <Grid
                              container
                              rowSpacing={2}
                              columnSpacing={2}
                              sx={{
                                width: 'calc(100% + 16px)',   // compensate spacing width
                                mr: '-16px',
                              }}
                            >
                              {filteredHolidayPackage?.Packages?.results?.slice(0, filterPackages || 9)?.map((item: any, index: number) => (
                                <Grid
                                  item
                                  xl={4}
                                  sm={6}
                                  xs={12}
                                  key={index}
                                  sx={{
                                    display: 'flex',
                                    minWidth: 0,
                                  }}
                                >
                                  <PackageCard
                                    // elementRef={elementRef}
                                    psw_result_id={
                                      filteredHolidayPackage?.FlightDetails?.outbound?.flights[0].psw_result_id
                                    }
                                    psw_result_id_combo={
                                      filteredHolidayPackage?.FlightDetails?.inbound?.flights[0].psw_result_id
                                    }
                                    item={item}
                                    viewMode={viewMode}
                                    index={index}
                                  />
                                </Grid>
                              ))}
                            </Grid>
                          </Container>
                        ) : (
                          filteredHolidayPackage?.Packages?.results?.slice(0, filterPackages || 9)?.map((item: any, index: number) => (
                            <PackageCard
                              // elementRef={elementRef}
                              psw_result_id={
                                filteredHolidayPackage?.FlightDetails?.outbound?.flights[0].psw_result_id
                              }
                              psw_result_id_combo={
                                filteredHolidayPackage?.FlightDetails?.inbound?.flights[0].psw_result_id
                              }
                              item={item}
                              key={index}
                              viewMode={viewMode}
                              index={index}
                            />
                          ))
                        )}

                        {filteredHolidayPackage?.Packages?.results?.length > 9 && (
                          <Grid item xs={12}>
                            <Box sx={{
                              display: 'flex', justifyContent: 'center', mt: '20px',
                              '& .MuiButton-root': {
                                ':hover': {
                                  background: colors.basics.black,
                                  color: colors.basics.white,
                                  border: `1px solid ${colors.basics.white}`
                                }
                              }
                            }}>
                              {(() => {
                                const totalResults = filteredHolidayPackage?.Packages?.results?.length || 0;
                                const hasMoreResults = filterPackages < totalResults;
                                const hasLoadedMore = filterPackages > getInitialCount;

                                if (hasMoreResults) {
                                  return (
                                    <Button variant="outlined" sx={{ textTransform: "capitalize", border: `1px solid ${colors.basics.black}`, borderRadius: "5px", fontFamily: "Raleway", fontWeight: 700, fontSize: "16px", lineHeight: "130%", color: colors.basics.black, ":hover": { background: colors.basics.black, color: colors.basics.white } }} onClick={handleLoadMore}>
                                      Load More
                                    </Button>
                                  );
                                } else if (hasLoadedMore) {
                                  return (
                                    <Button variant="outlined" sx={{ textTransform: "capitalize", border: `1px solid ${colors.basics.black}`, borderRadius: "5px", fontFamily: "Raleway", fontWeight: 700, fontSize: "16px", lineHeight: "130%", color: colors.basics.black, ":hover": { background: colors.basics.black, color: colors.basics.white } }} onClick={handleShowLess}>
                                      Show Less
                                    </Button>
                                  );
                                }
                                return null;
                              })()}
                            </Box>
                          </Grid>
                        )}
                      </Box>
                    ) : (
                      !loading &&
                      <>
                        <Typography variant='h1' marginTop={{
                          sm: 0, xs: "20px"
                        }} textAlign='center' color={colors.grey[40]} >
                          Unfortunately, no results were returned for the package you have searched.
                        </Typography>
                        <Typography variant='h1' marginBottom={{
                          sm: 0, xs: "20px"
                        }} textAlign='center' color={colors.grey[40]} >
                          Please search again for alternatives.
                        </Typography>
                      </>
                    )}
                  </>
                ) : (
                  !loading && <>
                    <Typography mt={{ xs: 6, sm: 5 }} px={{ xs: 1, sm: 0 }}
                      // marginTop={{
                      //   sm: 0, xs: "20px"
                      // }}
                      variant='h1' textAlign='center' color={colors.grey[40]} >
                      {isHolidayApiCall || queryData.UAT == '0' ? "Unfortunately, no results were returned for the package you have searched." : "Please complete the form above to explore our range of holidays."}
                    </Typography>
                    <Typography mb={{ xs: 6, sm: 5 }}
                      // marginTop={{
                      //   sm: 0, xs: "20px"
                      // }}
                      variant='h1' textAlign='center' color={colors.grey[40]} >
                      {isHolidayApiCall || queryData.UAT == '0' ? "Please search again for alternatives." : ""}
                    </Typography>
                  </>
                )
                }

              </Box >


            </Box >

          </CustomContainer >
        </Box >
      </Box >
    </Box >
  );
};
